var shortVideo = {

    // 定位上一次点击视频
    toLastVideoPosition: function(){
        var videoId = sessionStorage.getItem('lastVisitVideoId');
        if (videoId){

            var videoItemLoaded = false;

            for (var i = 0; i < $('.video-list .content-item').length; i++) {
                var id = $($('.video-list .content-item')[i]).attr('data-id');
                console.log(id);
                if (id == videoId){
                    videoItemLoaded = true;
                }
            }

            console.log(videoId, videoItemLoaded);

            if (videoItemLoaded){
                $('html,body').animate({scrollTop:$("#"+videoId).offset().top - 100},800);
                sessionStorage.removeItem('lastVisitVideoId');
            }else{
                console.log($(document).height());
                setTimeout(function () {
                    $('html,body').animate({scrollTop:$(document).height()},800);
                },500)
            }
        }
    },

    setVisitorVideo: function(id){
        sessionStorage.setItem('lastVisitVideoId',id);
        window.location.href = '/video/'+id;
    },

    initScrollEvent: function(){
        $(window).scroll(function () {
            // console.log($(document).scrollTop());
            var bannerHeight = $('.video-swiper-container').height();
            var scrollTop = $(document).scrollTop();
            if (scrollTop <= bannerHeight){
                $('.short-video-top').css('background-color', 'rgba(0,0,0,0.3)');
                $('.short-video-top .video-tab').removeClass('video-tab-white');
            } else if($(document).scrollTop() > bannerHeight){
                $('.short-video-top').css('background-color', 'white');
                $('.short-video-top .video-tab').addClass('video-tab-white');
            }
        })
    },

    initSwiper: function(){
        var indexTag = $('.swiper-container-short-video .swiper-slide').index($('.swiper-container-short-video .tag-bg'));
        new Swiper('.swiper-container-short-video', {
          slidesPerView: 'auto',
          slidesOffsetAfter: 13,
          initialSlide: indexTag === -1 ? 0 : indexTag
        })

        var bannerSwiperConfig = {};
        if ($('#bannerCount').val() > 1){
            bannerSwiperConfig = {
                loop: true,
                autoplay: true,
                pagination:{
                    el: '.video-swiper-pagination',
                }
            }
        }
        new Swiper('.video-swiper-container',bannerSwiperConfig)
    },

    search: function (e) {
      var evt = window.event || e;
      if (evt.keyCode === 13) {
        var keyWord = document.getElementById('serach-video-input').value;
        var locationsearch =  window.location.search;
        if (locationsearch.indexOf('kw') > -1){
          locationsearch = common.changeUrlParams('kw',locationsearch, keyWord);
          window.location.href = '/video' + locationsearch;
        }else {
          locationsearch? (window.location.href = '/video' + locationsearch + "&kw=" + keyWord) : (window.location.href = '/video?kw=' + keyWord);
        }
      }
    },

  browse: function (id) {
    // 浏览量
    $.ajax({
      type: "GET",
      url: '/api/detail/browse/' + id,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    });
    return true
  },

  init: function () {
      var self = this;
      // this.initScrollEvent();
      window.onload = function () {
        self.initSwiper();
        // self.toLastVideoPosition();
      }

      // 加载完下一页之后 定位视频位置
      // window.cateData.infScroll.afterLoadMore = function() {
          // self.toLastVideoPosition()
      // }
  }
};
